import { FormikProps } from 'formik';
import { FeatureDescriptionInput, PersonaFeatureDescriptionInput } from '../../../../../types/FormTypes';
import { BasicInput } from '../../../../shared/inputs/BasicInput';

import styles from './FeatureNameInput.module.css';

type FeatureNameInputProps<T> = {
  formikProps: FormikProps<T>;
  disabled: boolean;
};

export function FeatureNameInput<T extends FeatureDescriptionInput | PersonaFeatureDescriptionInput>({
  formikProps,
  disabled,
}: FeatureNameInputProps<T>) {
  return (
    <div className={styles['container']}>
      <label className={styles['label']}>
        <h2>Name of the feature.</h2>
        <p>Name the feature that you want a description written for.</p>
      </label>
      <div className={styles['inputs-container']}>
        <BasicInput
          id="featureName"
          label={<></>}
          placeholder="Campaign task management"
          value={formikProps.values.featureName}
          setValue={formikProps.handleChange('featureName')}
          disabled={disabled}
          errors={formikProps.errors.featureName as string}
          touched={formikProps.touched.featureName ? true : false}
          onBlur={formikProps.handleBlur}
        />
      </div>
    </div>
  );
}
